module.exports = "<li class=\"weui_media_info_meta\" :class=\"{'weui_media_info_meta_extra': extra}\"><slot></slot></li>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/media/media-info-meta.vue
 ** module id = 174
 ** module chunks = 0
 **/